module.exports = __webpack_public_path__ + "static/media/1-7.a2e212cd.mp3";